// Create a custom history for the consumer app, to enable profiling using
// tools such as Sentry when run on the client side

import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

export default history;
